module.exports = "/images/Icon industry-WatherPark.svg?e24b98e41bc5e95108248af4f5c3485d";